import { createSlice } from "@reduxjs/toolkit";
import { Pagination } from "../../../utils/api";
import { Company } from "../../company-page/store/slice";

type InitialState = {
  data: Company[];
  meta: Pagination | null;
  isLoading: boolean;
};

const initialState: InitialState = {
  data: [],
  meta: null,
  isLoading: false,
};

const companySlice = createSlice({
  name: "companySlice",
  initialState,
  reducers: {
    fetchData: (state, action) => {
      state.isLoading = true;
    },
    setData: (state, action) => {
      const { data, meta } = action.payload;

      state.data = data;
      state.meta = meta;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    reset: () => initialState,
  },
});

export default companySlice;
